export { default } from './LocationsMap';
